export default {
  shouldBeHidden(content) {
    return content.classList.contains('sib-collapsible__content_toggled');
  },
  show() {},
  hide() {}
};